// 导出该模块（云桌面管理）state、actions、mutations
import actions from './actions'
import sceneDir from './metaData/sceneDir'
export default {
  state: sceneDir,
  actions
}
